var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-img",
    {
      ref: "pitchImg",
      staticClass: "my-5",
      style: { position: "relative", width: "100%", aspectRatio: "2 / 1" },
      attrs: { src: _vm.imgSrc, contain: "" },
    },
    [
      _c(
        "div",
        { staticClass: "drawable", style: _vm.drawableStyle },
        _vm._l(_vm.areas, function (area, i) {
          return _c(
            "div",
            { key: `${i}-${area.id}` },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    top: "",
                    color: "lightSecondary lighten-4",
                    "max-width": "300",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    key: area.id,
                                    staticClass: "area-toggle pa-0",
                                    style: _vm.getButtonStyle(area),
                                    attrs: {
                                      color:
                                        area.selected && _vm.selectable
                                          ? "red lighten-2"
                                          : "grey lighten-2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleArea(area)
                                      },
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c("span", { staticClass: "black--text body-1" }, [
                    _vm._v(
                      _vm._s(_vm.$t(`videoHighlights.areas.${area.name}`))
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }